<template>
    <span v-if="userStatus">
        <v-btn @click="logout"
               text
        >
            <span class="mr-2">LOGOUT</span>
            <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
    </span>
</template>

<script>
    import firebase from '@/plugins/firebase.js';

    export default {
        name: 'Logout',
        created: function() {
            firebase.onAuth();
        },
        computed: {
            user() {
                return this.$store.getters.user;
            },
            userStatus() {
                return this.$store.getters.isSignedIn;
            }
        },
        methods: {
            logout: function () {
                firebase.logout();
            }
        }
    }
</script>
